var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M1.2,30.4c1.1-4.4,6.6-6,9.8-2.8l21.6,21.6h16.6V32.6L27.7,11.1c-3.2-3.2-1.7-8.8,2.7-9.8 C40.6-1.2,57.1-0.8,69.9,12c11.2,11.2,14.8,27.9,9.5,42.7l66,66c14.8-5.3,31.5-1.7,42.7,9.5c12.5,12.5,13.2,29.2,10.7,39.5 c-1.1,4.4-6.6,6-9.8,2.8l-21.6-21.6h-16.6v16.6l21.6,21.5c3.2,3.2,1.7,8.8-2.7,9.8c-10.2,2.5-26.7,2.1-39.5-10.7 c-11.2-11.2-14.8-27.9-9.5-42.7l-66-66c-14.8,5.3-31.5,1.7-42.7-9.5C-0.6,57.5-1.3,40.8,1.2,30.4L1.2,30.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M100,141.4l-50,50c-10,10-25.5,11.3-36.9,3.7L58.3,150c2.3-2.3,2.3-6,0-8.3c-2.3-2.3-6-2.3-8.3,0 L4.8,186.9C-2.7,175.5-1.4,160,8.6,150l50-50L100,141.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M199.4,16.8l-16.6,33.1c-0.9,1.7-2.5,2.9-4.4,3.2L151.3,57l-26.5,26.5l-8.3-8.3L143,48.7l3.9-27.1 c0.3-1.9,1.5-3.6,3.2-4.4l33.1-16.6c2.3-1.1,5-0.7,6.8,1.1l8.3,8.3C200.1,11.8,200.5,14.5,199.4,16.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.622ad22e1a782a8202b35bf12ad4c85d.svg";
export { ForwardRef as ReactComponent };